<div class="container ready-for-tablet">
    <div class="row">
        <div class="col-md-8 col-sm-12 offset-md-2 offset-sm-0 mb-4">
            <div id="has-driver-log-note-complete" class="text-center">
                <img
                    src="/assets/images/driver_emails_generic.jpg"
                    alt="Octopus Logo"
                    style="max-width: 100%"
                    class="mb-4"
                />
            </div>
            <p>
                Welcome, <span>{{ userSummary?.first_name }}.</span>
            </p>
            <br />
            <p>
                Your application has been put on hold. To restart your
                application, please email
                <a href="mailto:contact&#64;playoctopus.com"
                    >contact&#64;playoctopus.com</a
                >.
            </p>
            <br />
            <p>
                Thanks,<br />
                The Play Octopus Team
            </p>
            <br />
            <hr />
            <br />

            <p>
                Bienvenido, <span>{{ userSummary?.first_name }}.</span>
            </p>
            <br />
            <p>
                Su solicitud ha sido puesta en espera. Para reiniciar su
                aplicación, envíe un correo electrónico a
                <a href="mailto:contact&#64;playoctopus.com"
                    >contact&#64;playoctopus.com</a
                >.
            </p>
            <br />
            <p>
                Gracias,<br />
                El Equipo Play Octopus
            </p>
            <br />
            <br />
        </div>
    </div>
</div>
